import { render, staticRenderFns } from "./jsaRiskRegister.vue?vue&type=template&id=74d8f914"
import script from "./jsaRiskRegister.vue?vue&type=script&lang=js"
export * from "./jsaRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d8f914')) {
      api.createRecord('74d8f914', component.options)
    } else {
      api.reload('74d8f914', component.options)
    }
    module.hot.accept("./jsaRiskRegister.vue?vue&type=template&id=74d8f914", function () {
      api.rerender('74d8f914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/risk/jsaRiskRegister.vue"
export default component.exports